import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

import DragAndDropOverlayImg from 'img/illustrations/drag-and-drop-overlay.svg';

import './styles.less';

class SharePageDropzone extends Component {
  state = {
    dragging: false,
  };

  render() {
    const { multiple = false } = this.props;
    const { dragging } = this.state;

    return (
      <Dropzone
        className="share-page-dropzone"
        disableClick={true}
        multiple={multiple}
        disabled={false}
        activeStyle={{ zIndex: 1000 }}
        onDragEnter={() => this.setState({ dragging: true })}
        onDragLeave={() =>
          this.setState({
            dragging: false,
          })
        }
        onDrop={this.handleDrop}
      >
        {dragging && <div className="share-page-drag-and-drop-overlay" />}
        {dragging && (
          <img
            src={DragAndDropOverlayImg}
            className="drag-and-drop-overlay-image"
          />
        )}
      </Dropzone>
    );
  }

  handleDrop = files => {
    this.setState({ dragging: false });
    this.props.onDrop(files);
  };
}

export default SharePageDropzone;
